import { render } from "./TextEditor.vue?vue&type=template&id=1e37e7c6&scoped=true"
import script from "./TextEditor.vue?vue&type=script&lang=ts"
export * from "./TextEditor.vue?vue&type=script&lang=ts"

import "./TextEditor.vue?vue&type=style&index=0&id=1e37e7c6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1e37e7c6"

export default script